import axios from 'axios';
import environment from '../environment';
import { authenticationService } from './auth.service';
import { getCurrentSlug, SLUG_HEADER_NAME } from '../utils/slug';

const api = axios.create({
    baseURL: environment.apiUrl
});

api.interceptors.request.use(function (config) {
    const slug = getCurrentSlug();
    const headers = {
        ...(config.headers || {})
    };

    if (authenticationService.currentUserValue && config.url !== 'login') {
        headers['Authorization'] = `Bearer ${authenticationService.currentUserValue?.token }`;
        headers['Access-Control-Allow-Origin'] = `${environment.url}`;
    }

    if (slug) {
        headers[SLUG_HEADER_NAME] = slug;
    }

    config.headers = headers;

    return config;
}, async function (error) {
    if (error.response.status === 401) {
        await authenticationService.logout(window.location.pathname);
    }
    return Promise.reject(error);
});

api.interceptors.response.use(function (response) {
    if (response.data?.success === false) {
        return Promise.reject(response.data);
    }
    
    return response;
}, async function (error) {
    if (error.response?.status === 401) {
        await authenticationService.logout(window.location.pathname);
    }
    
    if (error.response?.status === 404) {
        return Promise.reject({messages: ['Recurso não encontrado']});
    }
    
    if (error.response?.status === 403) {
        return Promise.reject({messages: ['Acesso negado']});
    }

    return Promise.reject(error.response?.data);
});


export default api;